module.exports = __webpack_public_path__ + "static/logohi-cad6ed78184e0bec2af65e0953182e27.svg";